import React, { PropsWithChildren } from 'react';
import { Alert, BackHandler, Platform, StyleSheet, View } from 'react-native';

import { AgeRestrictionBlock } from '@fhs/ui';
import { useAgeGateDecision } from 'utils/age-gate';

const closeApp = () => {
  if (Platform.OS === 'android') {
    BackHandler.exitApp();
    return;
  }

  Alert.alert('Close App', 'Please close the app to exit.');
};

export const AgeGate = ({ children }: PropsWithChildren) => {
  const decision = useAgeGateDecision();

  if (decision === 'checking') {
    return <View style={styles.checkingScreen} testID="age-gate-checking" />;
  }

  if (decision === 'allow') {
    return <>{children}</>;
  }

  return (
    <View style={styles.screen} testID="age-gate-overlay">
      <AgeRestrictionBlock onCloseApp={closeApp} />
    </View>
  );
};

const styles = StyleSheet.create({
  checkingScreen: {
    flex: 1,
    backgroundColor: '#FFFFFF',
  },
  screen: {
    ...StyleSheet.absoluteFillObject,
    flex: 1,
    zIndex: 1000,
    elevation: 1000,
    backgroundColor: '#FFFFFF',
  },
});
